<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Χρήστες φορέα</u></h4>
        </div>
      </div>

      <div>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        @initialized="saveGridInstance"
        :data-source="organizationEmployees"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        @row-inserting="onRowInserting"
        @row-updating="onRowUpdating"
        @init-new-row="onInitNewRow"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        @row-removing="onRowRemoving"
        @row-validating="onRowValidating"
      >
        <DxPaging :page-size="20" />
        <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          mode="row"
          :use-icons="true"
        />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />

        <DxColumn
          caption="Κωδικός"
          data-field="Id"
          data-type="integer"
          :visible="false"
        >
        </DxColumn>

        <DxColumn
          caption="ΑΦΜ"
          data-field="Afm"
          data-type="string"
          width="110px"
          alignment="left"
        >
          <DxRequiredRule message="το ΑΦΜ είναι υποχρεωτικό" />
          <DxAsyncRule
            :validation-callback="AFM_validation"
            message="AFM problem"
          />
        </DxColumn>

        <DxColumn
          caption="Επίθετο"
          data-field="LastName"
          data-type="string"
          alignment="left"
        >
          <DxRequiredRule message="το Επίθετο είναι υποχρεωτικό" />
        </DxColumn>

        <DxColumn
          caption="Ονομα"
          data-field="FirstName"
          data-type="string"
          alignment="left"
        >
          <DxRequiredRule message="το Όνομα είναι υποχρεωτικό" />
        </DxColumn>

        <DxColumn
          caption="Ενεργός"
          data-field="IsActive"
          data-type="boolean"
          width="110px"
          alignment="center"
        >
          <!-- <DxRequiredRule message="η κατάσταση είναι υποχρεωτική"/> -->
        </DxColumn>

        <DxColumn
          caption="Έχει Συνδεθεί"
          data-field="IsUser"
          data-type="boolean"
          width="140px"
          alignment="center"
          :allow-editing="false"
        >
          <!-- <DxRequiredRule message="η κατάσταση είναι υποχρεωτική"/> -->
        </DxColumn>

        <DxColumn
          caption="Χρήστης Κινητού"
          data-field="IsMobileUser"
          data-type="boolean"
          width="150px"
          alignment="center"
        >
          <!-- <DxRequiredRule message="η κατάσταση είναι υποχρεωτική"/> -->
        </DxColumn>

        <DxColumn
          caption="PIN"
          data-field="MobilePin"
          data-type="string"
          width="80px"
          alignment="center"
        >
          <DxPatternRule
            pattern="^[0-9]+$"
            message="Χρησιμοποιείστε μόνο αριθμούς"
          />
        </DxColumn>

        <DxColumn
          caption="Πλήρης Πρόσβαση"
          data-field="HasFullAccess"
          data-type="boolean"
          width="100px"
          alignment="center"
        >
        </DxColumn>

        <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
        <DxValidationSummary />
        <template #masterDetailTemplate="{ data: masterrow }">
          <DetailTemplate :template-data="masterrow" />
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxRequiredRule,
  DxMasterDetail,
  DxAsyncRule,
  DxFilterRow,
  DxSearchPanel,
  DxPatternRule,
} from "devextreme-vue/data-grid";
import DxValidationSummary from "devextreme-vue/validation-summary";
import DetailTemplate from "./organizationEmployeeStructures";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxRequiredRule,
    DetailTemplate,
    DxMasterDetail,
    DxAsyncRule,
    DxValidationSummary,
    DxFilterRow,
    DxSearchPanel,
    BackButton,
    DxLoadIndicator,
    DxPatternRule,
  },
  data() {
    return {
      organizationEmployees: [],
      dataGridInstance: null,
      loadIndicatorVisible: false,
    };
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    onInitNewRow(e) {
      e.data.IsActive = true;
      e.data.HasFullAccess = true;
    },
    async onRowRemoving(e) {
      console.log("--------->", e);
      const res = await mainService.delete(
        `/OrganizationEmployees/DeleteOrganizationEmployee?organizationEmployeeId=${e.data.Id}`
      );
      if (res.data == false) {
        e.cancel = true;
        notify(
          "Αποτυχία διαγραφής.Υπάρχει χρήστης με αυτή την εγγραφή.",
          "error",
          5000
        );
        return;
      }
      notify("Ο χρήστης φορέα διαγράφηκε επιτυχώς!", "success", 3000);
    },
    async onRowInserting(e) {
      var organizationEmployee = e.data;
      organizationEmployee.OrganizationId = this.organizationId;

      // We convert mobile pin to string to avoid type missmatch on 1st mobile pin assign.
      if (organizationEmployee.MobilePin != null)
        organizationEmployee.MobilePin =
          organizationEmployee.MobilePin.toString();

      try {
        var canExpand = true;
        const res = await mainService.post(
          "/OrganizationEmployees/AddOrganizationEmployee",
          organizationEmployee
        );
        if (res.status != 200) {
          canExpand = false;
          e.cancel = true;
        }

        this.getOrganizationEmployees();
        if (canExpand) {
          this.dataGridInstance.expandRow(res.data.Id);
        }
      } catch (error) {
        console.log(error);
        e.cancel = true;
      }
    },
    async onRowUpdating(e) {
      // We convert mobile pin to string to avoid type missmatch on 1st mobile pin assign.
      if (e.newData.MobilePin != null)
        e.newData.MobilePin = e.newData.MobilePin.toString();

      var organizationEmployee = Object.assign(e.oldData, e.newData);
      organizationEmployee.Id = e.key;
      organizationEmployee.OrganizationId = this.organizationId;

      try {
        const res = await mainService.post(
          "/OrganizationEmployees/UpdateOrganizationEmployee",
          organizationEmployee
        );
        if (res.status == 200 && res.data.Id == null) {
          e.cancel = true;
          notify(res.data, "error", 5000);
        }
        notify("Η αποθήκευση πέτυχε", "success", 1000);
      } catch (error) {
        console.log(error);
        e.cancel = true;
      }
    },
    onRowValidating(e) {
      if (e.newData.MobilePin.toString().length > 6) {
        e.errorText = "To PIN δεν μπορεί να είναι μεγαλύτερο από 6 χαρακτήρες.";
        e.isValid = false;
      }
    },
    AFM_validation(params) {
      var organizationEmployeeId =
        params.data.Id == undefined ? 0 : params.data.Id; //0 is in case of add record

      return new Promise((resolve, reject) => {
        mainService
          .get(
            `/OrganizationEmployees/CheckAfm?organizationEmployeeId=${organizationEmployeeId}&organizationId=${this.organizationId}&afm=${params.value}`
          )
          .then((res) => {
            res.data == "" ? resolve() : reject(res.data);
          })
          .catch((error) => {
            console.error("Server-side validation error", error);
            reject("Cannot contact validation server");
          });
      });
    },
    async getOrganizationEmployees() {
      this.loadIndicatorVisible = true;
      this.organizationEmployees = [];
      const res = await mainService.get(
        "/OrganizationEmployees/GetOrganizationEmployees?organizationId=" +
          this.organizationId
      );
      this.organizationEmployees = res.data;
      this.loadIndicatorVisible = false;
    },
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      this.dataGridInstance.collapseAll(-1);
      this.getOrganizationEmployees();
    },
  },

  async mounted() {
    this.getOrganizationEmployees();
  },
};
</script>

  <style scoped>
.dx-overlay-wrapper {
  max-width: 100px !important;
}

.dx-toast-message {
  width: 100px !important;
}
</style>